(function() {
	'use strict';

	angular
		.module('app.setup')
		.controller('projectGeneralCustomerSettings', projectGeneralCustomerSettings);

	projectGeneralCustomerSettings.$inject = ['$rootScope', '$scope', '$timeout', 'customerSettingService', 'storeService'];

	function projectGeneralCustomerSettings($rootScope, $scope, $timeout, customerSettingService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;	
		var backupValues = {};

		vm.disableSave = false;
		vm.resetValues = resetValues;
		vm.saveProjectGeneralSettings = saveProjectGeneralSettings;
		vm.changesMade = changesMade;

		// var pageLoaded = false;
		vm.actualSavingsOptions = [
			{ name: 'All Projects', value: false },
			{ name: 'Projects with approved savings only', value: true }
		];

		init();

		function init() {
			customerSettingService.getCustomerSettings([
				'onlyReportLeanProjectApprovedActualSavings'
			], adminConfig.factory.id).then(function (data) {
				vm.approvedOnly = data.onlyReportLeanProjectApprovedActualSavings;
				backupValues.approvedOnly = vm.approvedOnly;
			});
		}

		function saveProjectGeneralSettings() {
			vm.disableSave = true;
			var customerSetting = {
				'onlyReportLeanProjectApprovedActualSavings': vm.approvedOnly ? 1 : 0
			};
			if (vm.approvedOnly !== backupValues.approvedOnly) {
				customerSettingService.saveCustomerSettings(customerSetting, adminConfig.factory.id).then(function (response) {
					backupValues.approvedOnly = vm.approvedOnly;
					$rootScope.$emit('toast', {
						'message': response,
						'success': response === 'Settings saved successfully'
					});
					vm.disableSave = false;
				});
			} else {
				vm.disableSave = false;
			}
		}

		function resetValues() {
			vm.approvedOnly = backupValues.approvedOnly;
		}

		function changesMade() {
			return vm.approvedOnly !== backupValues.approvedOnly;
		}
	};
})();
